import { Layout, Menu } from "antd";
import React, { useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./style.css";
import { images } from "../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowsToEye,
  faCartPlus,
  faPercent,
  faShop,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const { Content, Footer, Sider } = Layout;

const sidebarTabs = [
  {
    key: "users",
    label: "Users",
    icon: <FontAwesomeIcon icon={faUserGroup} />,
  },
  {
    key: "category",
    label: "Category",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "products",
    label: "Products",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "orders",
    label: "Orders",
    icon: <FontAwesomeIcon icon={faCartPlus} />,
  },
  {
    key: "articles",
    label: "Testimonials",
    icon: <FontAwesomeIcon icon={faNewspaper} />,
  },
  {
    key: "tips",
    label: "Tips",
    icon: <FontAwesomeIcon icon={faNewspaper} />,
  },
  {
    key: "specialOffers",
    label: "SpecialOffers",
    icon: <FontAwesomeIcon icon={faPercent} />,
  },
  {
    key: "AddSlider",
    label: "AddSlider",
    icon: <FontAwesomeIcon icon={faArrowsToEye} />,
  },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((st) => st.auth);

  useLayoutEffect(() => {
    if (userData?.role !== "admin") {
      navigate("/");
    }
  }, []);

  const handleTabClick = (event) => {
    const clickedTabKey = event.key;
    navigate(`/dashboard/${clickedTabKey}`);
  };
  return (
    <Layout className="dashboard" hasSider>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {}}
        onCollapse={(collapsed, type) => {}}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div
          className="logo"
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={images.logo} alt="logo" style={{ width: "100%" }} />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["users"]}
          items={sidebarTabs}
          onClick={handleTabClick}
        />
      </Sider>
      <Layout
        style={{
          marginLeft: 200,
        }}
      >
        <Content
          style={{
            margin: "0 16px 0",
          }}
        >
          <div className="site-layout-background content">
            <Outlet />
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          prosoft
        </Footer>
      </Layout>
    </Layout>
  );
};
export default Dashboard;
